// extracted by mini-css-extract-plugin
export default {"signUpForm":"styles_signUpForm__W6IXL","label":"styles_label__-9cRv","input":"styles_input__u-UTT","signUpForm-mobile":"styles_signUpForm-mobile__2+z1R"};